"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

require("../css/avatar.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Avatar = function Avatar(_ref) {
  var image = _ref.image,
      ring = _ref.ring,
      otherProps = _objectWithoutProperties(_ref, ["image", "ring"]);

  return _react.default.createElement("div", {
    className: (0, _classnames.default)({
      'vn-avatar': true,
      'vn-avatar--ring': ring
    })
  }, image && _react.default.createElement("img", _extends({
    alt: "",
    src: image,
    className: "vn-avatar__image"
  }, otherProps)), !image && _react.default.createElement(_icon.default, _extends({
    name: "user"
  }, otherProps)));
};

Avatar.propTypes = {
  image: _propTypes.default.string,
  ring: _propTypes.default.bool
};
Avatar.defaultProps = {
  image: null,
  ring: false
};
Avatar.displayName = 'Avatar';
var _default = Avatar;
exports.default = _default;